// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleHeading_root__PthV3","hed1":"ArticleHeading_hed1__l_bfx","hed2":"ArticleHeading_hed2__pXhtQ","hed3":"ArticleHeading_hed3__aEha9","hed4":"ArticleHeading_hed4__uw2lO"};